import { Clickable, Col, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';

const SegmentControl = ({ options, selectedIdx, handleSelect }) => {
  const { t } = useTranslation();

  return (
    <Col wid="100%">
      <Row start>
        {options.map((x, i) => (
          <Clickable key={i} onClick={() => handleSelect(i)}>
            <Col noFlex pad="14px 24px 8px">
              <Text b2 bold col={selectedIdx === i ? '#000' : theme.GREY_60}>
                {t(x)}
              </Text>
            </Col>

            {selectedIdx === i && (
              <Col noFlex wid="100%" ht="4px" marg="0 0 -1px" bg={theme.SECONDARY} />
            )}
          </Clickable>
        ))}
      </Row>

      <Row wid="100%" ht="1px" bg={theme.GREY_20} />
    </Col>
  );
};

export default SegmentControl;
